import { Button, Descriptions, Select, Space } from 'antd';
import { memo, useContext, useState } from 'react';

const SupportingArticlesFilters = ({
    filtersList,
    localFiltersApplied,
    setLocalFiltersApplied,
    handleApplyFilters,
    handleCancelFilters,
    handleResetFilters,
    studioId,
}) => {
    console.log('filtersList:----- ', filtersList);

    const getOptions = item => {
        let valuesOptions = [];
        if (item?.values?.length > 0) {
            valuesOptions = item?.values?.map(el => {
                return {
                    label: el,
                    value: el,
                };
            });
        }
        return valuesOptions;
    };

    const getValue = item => {
        return localFiltersApplied[item?.key] ?? [];
    };

    const handleChangeAppliedFilters = (e, key) => {
        let localFilters = { ...localFiltersApplied };
        if (!localFilters[key]) {
            localFilters[key] = [];
        }
        localFilters[key] = [...e];

        if (e?.length === 0) {
            delete localFilters[key];
        }
        setLocalFiltersApplied(localFilters);
    };

    return (
        <div style={{ position: 'relative', height: '100%' }}>
            <Descriptions title="">
                {filtersList.map((item, index) => {
                    return (
                        <Descriptions.Item label={item?.key} key={index} span={1}>
                            <Select
                                mode="multiple"
                                allowClear
                                style={{
                                    width: '100%',
                                }}
                                placeholder="Please select"
                                onChange={e => handleChangeAppliedFilters(e, item?.key)}
                                maxTagTextLength={4}
                                maxTagCount={2}
                                value={getValue(item)}
                                options={getOptions(item)}
                            />
                        </Descriptions.Item>
                    );
                })}
            </Descriptions>
            <Space style={{ position: 'absolute', bottom: '0' }}>
                <Button onClick={handleApplyFilters}>Submit</Button>
                <Button onClick={handleResetFilters}>Reset</Button>
            </Space>
        </div>
    );
};

export default memo(SupportingArticlesFilters);
